<template>
  <div class="column" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Column',
  props: {
    type: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 12
    },
    sizes: {
      type: Array,
      default () {
        return []
      }
    },
    offset: {
      type: Number,
      default: 0
    },
    breakpoints: {
      type: Array,
      default () {
        return ['xs', 'sm', 'md', 'lg']
      }
    }
  },
  computed: {
    classes () {
      return `col-md-${this.size}`
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// Column.vue?31db8112